module.exports = {"Type":"CallScenarioByIntent","Fields":[{"label":"Intent","type":"intent","name":"intent"},{"label":"Entity","type":"entities","name":"entities"},{"label":"Keywords","name":"keywords"}],"Header":{"Color":"white","BackgroundColor":"cornflowerblue","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/CallScenarioByIntent.json
// module id = 684
// module chunks = 0